import { render, staticRenderFns } from "./AshoreCrewCard.vue?vue&type=template&id=23bc5086&scoped=true"
import script from "./AshoreCrewCard.vue?vue&type=script&lang=js"
export * from "./AshoreCrewCard.vue?vue&type=script&lang=js"
import style0 from "./AshoreCrewCard.vue?vue&type=style&index=0&id=23bc5086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc5086",
  null
  
)

export default component.exports